module.exports = __webpack_public_path__ + "img/1557614103454883842.0389b27b.png";